const createSingleQuery = (search_fields, lookup, search) => ({
  search_fields,
  lookup,
  search
});

export default createSingleQuery;
